import request from '@/utils/request'


//组织机构列表
export function selectEnterpriseListByOrgId(orgId, log) {
  return request({
    url: '/sys/org/selectEnterpriseListByOrgId/' + orgId,
    method: 'get',
    log: log
  })
}

//获取所有国家列表
export function getCountryList(log) {
  return request({
    url: '/sys/org/loadAllCountry',
    method: 'get',
    log: log
  })
}
//新增组织机构
export function addOrg(data,  log) {
  return request({
    url: '/sys/org',
    method: 'post',
    data,
    log
  })
}
//更新组织机构
export function updataOrg(data, log) {
  return request({
    url: '/sys/org',
    method: 'PUT',
    data,
    log
  })
}
//更新组织机构
// export function updataOrg(data, header) {
//     return request({
//         url: '/baseData/location',
//         method: 'PUT',
//         headers: header,
//         data
//     })
// }

//查询市级区域列表
export function getlLocationList(header,log) {
  return request({
    url: '/baseData/location/list',
    method: 'post',
    headers: header,
    log,
    data: {
      querys: [{
        "eq": {}
      }]
    }
  })
}

//删除组织机构
export function deleteOrg(id, log) {
  return request({
    url: `/sys/org/delete/${id}`,
    method: 'delete',
    log
  })
}

//删除批量用户组织
export function deleteUserFromOrg(ids, orgIds, log) {
  return request({
    url: `/sys/user/deleteOrg/${ids}/${orgIds}`,
    method: 'delete',
    log
  })
}
//批量配置用户组织
export function saveUserOrg(userIds, orgIds, header, log) {
  return request({
    url: `/sys/user/saveUserOrg/${userIds}/${orgIds}`,
    method: 'post',
    headers: header,
    log
  })
}

//根据ID获取详情
export function selectEnterpriseById(orgId, log) {
  return request({
    url: `/sys/org/selectEnterpriseById/${orgId}`,
    method: 'get',
    log
  })
}

//校验部门下是否存在员工
export function queryCount(orgId, log) {
  return request({
    url: `/sys/org/queryCount/${orgId}`,
    method: 'get',
    log
  })
}

//判断部门下是否有员工接收mds
export function queryDepartCountRec(orgId, log) {
  return request({
    url: `/sys/org/queryDepartCountRec/${orgId}`,
    method: 'get',
    log
  })
}

//判断部门下是否有员工发送过mds
export function queryDepartCountSend(orgId, log) {
  return request({
    url: `/sys/org/queryDepartCountSend/${orgId}`,
    method: 'get',
    log
  })
}
